<template>
  <page logoHref="/admin/orders" class="home-page">
    <loader :isLoaderOn="loaderOn"></loader>
    <div class="container">

      <div
        class="d-flex flex-row justify-content-start mt-4 align-middle"
        style="gap: 32px"
      >
        <div>
          <button
            class="btn btn-secondary font-weight-bold"
            v-on:click="backToResults"
            :disabled="disableButtons"
          >
            &lt; Back to<br class="hide-br" />&nbsp;&nbsp; Results
          </button>
        </div>
        <div class="d-flex flex-column" style="font-size: 20px; color: black">
          <div><b>Order #: </b> {{ record.id }}</div>
          <div>
            <b>Product: </b>
            <span>Tax Return Extension</span>
          </div>
        </div>

        <div class="mt-3">
          <button
            :class="['btn', 'btn-secondary', 'font-weight-bold']"
            @click="isEditMode = true"
            :disabled="disableButtons || record.status == 'Charge Back' || record.status == 'Cancelled'"
            v-if="editRecordAuth"
          >
            <!-- <font-awesome-icon :icon="['fa', 'pencil-alt']" />-->
            Edit
          </button>
        </div>
        <div class="mt-3">
          <button
            class="btn btn-warning font-weight-bold"
            @click="saveOrderDetails()"
            :disabled="disableButtons || !isEditMode"
          >
            Save Order Details
          </button>
          <div class="text-success" v-if="addressesSaved">Details Saved</div>
        </div>
      </div>
      <hr />

      <div class="row">
        <div
          class="d-flex col-12 col-sm-6 col-md-6 flex-column"
          style="border-right: 4px solid black; display: none"
        >
          <div class="d-flex mb-3">
            <h3>Basic Info</h3>
          </div>
          <div class="d-flex mb-3 align-middle">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Submitted Date:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              {{ record.createdDate }}
            </div>
          </div>
          <div class="d-flex mb-3 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Customer IP:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              {{ record.customerIpAddress }}
            </div>
          </div>
          <div class="d-flex mb-3 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>IRS E-file Confirmation Number:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <b>{{ record.efileStatus == 'Accepted' ? record.efileSubmissionId : "&mdash;" }}</b>
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>First Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.firstName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Middle Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.middleName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Last Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.lastName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Email:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.email"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Phone:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.phone"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <!-- Don't remove, just a e-File marker, not editable, all Form 4868 orders are e-File -->
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Is E-File?</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="checkbox"
                style="transform: scale(1.5); margin-left: 4px;"
                checked
                disabled
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Birth Date (MM/DD/YYYY):</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                class="form-control"
                type="date"
                v-model="record.birthDate"
                placeholder="MM/DD/YYYY"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Prior Year AGI:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.priorYearAgi"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Self-Select PIN:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.priorYearPin"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Birth Date (MM/DD/YYYY):</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                class="form-control"
                type="date"
                v-model="record.spouseBirthDate"
                placeholder="MM/DD/YYYY"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Prior Year AGI:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.spousePriorYearAgi"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Self-Select PIN:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.spousePriorYearPin"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <hr />

          <notes-manager
            :notesHolder="record"
            @onUpdate="onConfirmRefresh"
          />

          <hr />

          <div class="d-flex mb-3">
            <h3>Transaction Info</h3>
          </div>
          <div class="d-flex mb-2 align-middle">
            <table style="width: 100%">
              <tr>
                <td class="font-weight-bold" colspan="2">
                  Basic Information
                </td>
              </tr>
              <tr>
                <td>Charge Amount:</td>
                <td>${{ parseInt(record.amount, 10) / 100 }}</td>
              </tr>
              <tr>
                <td>Card Brand:</td>
                <td>{{ record.cardBrand }}</td>
              </tr>
              <tr>
                <td>Last Four of Card Number</td>
                <td>{{record.last4DigitsCard}}</td>
              </tr>
              <tr>
                <td>Original Payment Date</td>
                <td>{{record.submissionDate}}</td>
              </tr>

              <tr>
                <td class="font-weight-bold" colspan="2">Refund Information</td>
              </tr>
              <tr>
                <td>Voided</td>
                <td>{{ record.status != 'Cancelled' ? '' : record.refundDate ? '' :  'Yes' }}</td>
              </tr>
              <tr>
                <td>Refunded</td>
                <td>{{ record.status == 'Cancelled' && !record.refundDate ? '' : record.refundDate ? 'Yes' :  ''}}</td>
              </tr>
              <tr>
                <td>Refund Orbital Transaction ID</td>
                <td>{{ record.refundAuthTransId }}</td>
              </tr>
              <tr>
                <td>Refund Date</td>
                <td>{{ record.refundDate != null ? new Date(record.refundDate).toLocaleDateString() : '' }}</td>
              </tr>

              <tr>
                <td class="font-weight-bold" colspan="2">
                  Orbital Information
                </td>
              </tr>

              <tr>
                <td>Orbital Original Transaction ID</td>
                <td>{{record.orbitalTransactionNumber}}</td>
              </tr>
              <tr>
                <td>Orbital Decline Reason</td>
                <td>{{record.authorizeErrorMessage}}</td>
              </tr>
              <tr>
                <td>Orbital Error Code</td>
                <td>{{ record.authorizeErrorCode == "00" ? "" : record.authorizeErrorCode }}</td>
              </tr>

              <tr>
                <td class="font-weight-bold" colspan="2">Cardinal 3D Secure Information</td>
              </tr>

              <tr>
                <td>Cardinal Trans ID</td>
                <td>{{ record.transactionId }}</td>
              </tr>
              <tr>
                <td>ECI Code</td>
                <td>{{record.eciFlag}}</td>
              </tr>
              <tr>
                <td>Authentication Result</td>
                <td>{{record.authorizeErrorMessage}}</td>
              </tr>
              <tr>
                <td>Cardinal Response</td>
                <td>{{ record.authorizeErrorMessage == "Success" ? "YAY" : ""}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="d-flex col-12 col-sm-6 col-md-6 flex-column">
          <div class="d-flex mb-3">
            <h3>Status</h3>
          </div>
          <div class="d-flex flex-column mb-2 align-middle">
            <div class="d-flex mb-3">
              <b class="mt-2">
                {{ record.status }}
              </b>
              <div class="ml-3"
                v-if="
                (record.status !== 'Cancelled') &&
                (loggedInUser.userType == 'admin' ||
                (loggedInUser.userType == 'StandardUser' && loggedInUser.manualStatusChange))
              ">
                <select
                  class="form-control"
                  v-model="manualStatus"
                  @change="$refs.manualStatusChangeModal.show()"
                >
                  <option value="" disabled selected hidden>Change Status...</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
            </div>

            <div class="d-flex" style="gap: 20px">
              <div v-if="record.status !== 'Cancelled'">
                <button
                  class="btn btn-secondary font-weight-bold"
                  @click="showHideCancelOrderConfirmation(true)"
                  v-if="statusChangeAuth"
                  :disabled="isChargeBackAvailable(record.status)"
                >
                  Cancel <span v-if="record.amount !== '0'">and Refund</span>
                </button>
              </div>

              <div v-if="record.status !== 'Cancelled' && record.status !== 'Incomplete'">
                <button
                  class="btn btn-secondary font-weight-bold"
                  @click="clickOnHoldButton()"
                  v-if="statusChangeAuth"
                  :disabled="disableButtons && !isEditMode"
                >
                  {{ record.status === "On Hold" ? "Remove Hold" : "Put On Hold" }}
                </button>
              </div>

              <div
                v-if="record.amount !== '0' && record.status !== 'Incomplete'"
              >
                <button
                  class="btn btn-secondary font-weight-bold"
                  @click="clickOnChargebackButton()"
                  :disabled="isChargeBackAvailable(record.status)"
                  v-if="
                    loggedInUser.userType == 'admin' ||
                    (loggedInUser.userType == 'StandardUser' &&
                      loggedInUser.chargebackAuth)
                  "
                >
                  Chargeback
                </button>
              </div>

            </div>
          </div>

          <hr />

          <div class="d-flex mb-3">
            <h3>e-File Submission</h3>
          </div>

          <div class="d-flex mb-3">
            <button @click="submitForm()"
                    class="btn btn-secondary font-weight-bold mr-3"
                    :disabled="disableButtons || ['Accepted'].includes(record.efileStatus) || submissionInProgress">
              Submit &nbsp;<font-awesome-icon icon="fa-regular fa-clock" v-if="submissionInProgress"/>
            </button>
            <button @click="fetchAckResponse()"
                    class="btn btn-primary font-weight-bold"
                    :disabled="disableButtons || !['Ack Response Error'].includes(record.efileStatus) || fetchAckInProgress">
              Fetch Ack Response &nbsp;<font-awesome-icon icon="fa-regular fa-clock" v-if="fetchAckInProgress"/>
            </button>
          </div>

          <div class="d-flex"><b>Submission Result:</b></div>
          <div class="d-flex flex-column mb-2 align-middle">
            <div v-if="!record.efileSubmission">
              <i>Not submitted yet</i>
            </div>
            <div v-if="!!record.efileSubmission">
              <div class="d-flex">
                <div
                  style="color: #2e85f5; cursor: pointer"
                  @click="downloadSubmissionXML(record.id)">
                  <u><b>submission_{{record.id}}.xml</b></u>
                </div>
              </div>
              <div class="d-flex mb-2">
                <div
                  style="color: #2e85f5; cursor: pointer"
                  @click="downloadManifestXML(record.id)">
                  <u><b>manifest_{{record.id}}.xml</b></u>
                </div>
              </div>

              <div class="d-flex">
                <span>
                  Submission Id: <b>{{record.efileSubmissionId}}</b>
                </span>
              </div>

              <div class="d-flex" v-if="!!record.efileSubmissionDate">
                <span>
                  Submission Date: <b>{{record.efileSubmissionDate}}</b>
                </span>
              </div>

              <div class="d-flex">
                <span>
                  Status: <b :style="record.efileStatus == 'Accepted' ? 'color: green;' : 'color: red;'">
                    {{record.efileStatus}}
                  </b>
                </span>
              </div>

              <!-- TODO: Handle PIN codes if logic will be changed, currently constant values -->
              <div class="d-flex">
                <span>
                  User PIN: <b>82549</b>
                </span>
              </div>
              <div class="d-flex">
                <span>
                  Practitioner PIN: <b>82549</b>
                </span>
              </div>
            </div>

            <div v-if="!!record.efileAckResponse">
              <div class="d-flex" v-if="!!record.efileErrorCodes && !!record.efileErrorCodes.entries && record.efileErrorCodes.entries.length > 0">
                <span>
                  Error Codes: <a
                     style="color: #2e85f5; cursor: pointer"
                     @click="onForm4868ErrorCodes(record)">
                     <b>{{form4868ErrorCodesLabel(record)}}</b>
                   </a>
                </span>
              </div>

              <div class="d-flex mt-2">
                <!-- TODO: Might be needed later
                <i v-if="!record.efileStatus">No ack response yet</i>
                -->

                <div
                  style="color: #2e85f5; cursor: pointer"
                  @click="downloadAckResponseXML(record.id)">
                  <u><b>ack_response_{{record.id}}.xml</b></u>
                </div>
              </div>
            </div>

          </div>

          <hr />

          <div class="d-flex mb-3">
            <h3>Additional Details</h3>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>SSN:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.ssn"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Phone Number:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.phone"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Is Married?:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="checkbox"
                v-model="record.married"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse First Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.spouseFirstName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Middle Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.spouseMiddleName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Last Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.spouseLastName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse SSN:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.spouseSsn"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Currently outside the country?:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="checkbox"
                v-model="record.abroad"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Total Liability:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.totalLiability"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Total Payments:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.totalPayments"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Is schedule EFW payment?:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="checkbox"
                v-model="record.schedulePayment"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Routing Number:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.routingTransitNumber"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Account Number:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.bankAccountNumber"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Account Type:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <select
                class="form-control"
                v-model="record.bankAccountType"
                :disabled="!isEditMode"
              >
                <option value="1">Checking</option>
                <option value="2">Savings</option>
              </select>
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Payment Amount:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.paymentAmount"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Payment Date:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.paymentDate"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <hr />
          <div class="d-flex mb-3">
            <h3>Billing Address</h3>
          </div>

          <div class="d-flex flex-column mb-2 align-middle">
            <div class="d-flex">
              <input
                type="text"
                class="form-control"
                v-model="record.address1"
                :disabled="!isEditMode"
              />
            </div>
            <div class="d-flex">
              <input
                type="text"
                class="form-control"
                v-model="record.address2"
                :disabled="!isEditMode"
              />
            </div>
            <div class="d-flex flex-row">
              <input
                type="text"
                class="form-control"
                v-model="record.city"
                :disabled="!isEditMode"
              />
              <input
                type="text"
                class="form-control"
                v-model="record.state"
                :disabled="!isEditMode"
              />
              <input
                type="text"
                class="form-control"
                v-model="record.zip"
                :disabled="!isEditMode"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="backConfirmation" hide-footer title="Alert">
      <div class="row">
        <div class="col">
          <p>Are you sure? Edits are not saved!</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            class="btn btn-success pl-4 pr-4 text-dark"
            @click="backToResults(true)"
          >
            <b>YES</b>
          </button>
          <button
            class="btn btn-warning pl-4 pr-4 text-dark"
            @click="backToResults(false)"
          >
            <b>NO</b>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="offHoldModal"
      hide-footer
      :title="record.status === 'On Hold' ? 'Take Off Hold' : 'Put On Hold'"
    >
      <div class="row">
        <div class="col">
          <p>Would you like to send an email notification to the customer?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="putOnHold(true)">
            Send Notification
          </button>
          <button class="btn btn-warning" @click="putOnHold(false)">Don't Send</button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="cbStatusModal" hide-footer title="Chargeback Status">
      <div class="row">
        <div class="col">
          <p>Is this a CDRN or Chase Chargeback?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="chargebackCDRN()">CDRN</button>
          <button class="btn btn-warning" @click="chargebackChase()">CHASE</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="emailNotificationModel"
      hide-footer
      :title="emailNotificationModelData.title"
    >
      <div class="row">
        <div class="col">
          <p>{{ emailNotificationModelData.content }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="sendEmailNotification(true)">
            {{ emailNotificationModelData.sendButtonText }}
          </button>
          <button class="btn btn-warning" @click="sendEmailNotification(false)">
            {{ emailNotificationModelData.cancelButtonText }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="cancelOrderModel" hide-footer title="Cancel Order">
      <div class="row">
        <div class="col">
          <p>Are you sure?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            class="btn btn-success ml-1 float-right"
            @click="cancelOrder()"
          >
            Yes
          </button>
          <button
            class="btn btn-warning float-right"
            @click="showHideCancelOrderConfirmation(false)"
          >
            No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="manualStatusChangeModal" hide-footer title="Manual Status Change" @hidden="manualStatusChangeModalHidden()">
      <div class="row">
        <div class="col">
          <p>You are manually changing a status, are you sure?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success ml-1 float-right" @click="manualStatusChange()">
            Yes
          </button>
          <button
            class="btn btn-warning float-right"
            @click="hideManualStatusChangeModal()"
          >
            No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="f4868ModalErrorCodes"
      title="Form 4868 Error Codes"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div v-for="(error, idx) in (!!toShow && !!toShow.efileErrorCodes && toShow.efileErrorCodes.entries || [])" class="mb-2">
            <b>{{error.ruleNum}}</b><br/>
            <span>{{error.errorMessageTxt}}</span>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <button class="btn btn-outline-secondary" @click="closeForm4868ErrorCodesModal()">
          Cancel
        </button>
      </div>
    </b-modal>
  </page>
</template>

<!-- sharea sale tag -->
<script>
var shareasaleSSCID = shareasaleGetParameterByName("sscid");
function shareasaleSetCookie(e, a, r, s, t) {
  if (e && a) {
    var o,
      n = s ? "; path=" + s : "",
      i = t ? "; domain=" + t : "",
      l = "";
    r &&
      ((o = new Date()).setTime(o.getTime() + r),
      (l = "; expires=" + o.toUTCString())),
      (document.cookie = e + "=" + a + l + n + i);
  }
}
function shareasaleGetParameterByName(e, a) {
  a || (a = window.location.href), (e = e.replace(/[\[\]]/g, "\\$&"));
  var r = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(a);
  return r ? (r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "") : null;
}
shareasaleSSCID &&
  shareasaleSetCookie("shareasaleSSCID", shareasaleSSCID, 94670778e4, "/");
</script>

<script>
import { AXIOS } from "../scripts/http-common";
import { methods } from "../shared/methods";
import { clone } from "lodash";
import moment from "moment";
import { MONTHS, US_STATES } from "../scripts/constants";
import NotesManager from "./common/NotesManager.vue";

export default {
  components: {
    NotesManager
  },
  data() {
    return {
      isEditMode: false,
      autoEnabled: false,
      record: {
        birthDate: undefined,
        spouseBirthDate: undefined
      },
      pastRecord: {},
      disableButtons: false,
      submissionInProgress: false,
      fetchAckInProgress: false,
      notesSaved: false,
      addressesSaved: false,
      loggedInUser: "",
      statusChangeAuth: false,
      editRecordAuth: false,
      voidRefundAuth: false,
      loaderOn: false,
      manual_note: "",
      put_on_hold: "",
      emailNotificationModelData: {
        title: "",
        content: "",
        sendButtonText: "Send Notification",
        cancelButtonText: "Don’t Send",
      },
      manualStatus: "",
      toShow: {},
    };
  },
  created() {
    this.months = MONTHS;
    this.states = US_STATES;
  },
  methods: {
    fetchAckResponse() {
      console.log("Form 4868 ack response fetch confirmed.");

      let self = this;
      self.fetchAckInProgress = true;
      self.disableButtons = true;
      AXIOS.post(`/efile/form4868/fetch-ack/${this.record.id}`)
        .then((response) => {
          self.fetchAckInProgress = false;
          self.disableButtons = false;
          self.refresh();
        })
        .catch((e) => {
          alert("Unable to fetch Form 4868's ack response.");
          self.fetchAckInProgress = false;
          self.disableButtons = false;
        });
    },
    submitForm() {
      console.log("Form 4868 submission confirmed.");

      let self = this;
      self.submissionInProgress = true;
      self.disableButtons = true;
      AXIOS.post(`/efile/form4868/submit/${this.record.id}`)
        .then((response) => {
          self.submissionInProgress = false;
          self.disableButtons = false;
          self.refresh();
        })
        .catch((e) => {
          alert("Unable to submit Form 4868.");
          self.submissionInProgress = false;
          self.disableButtons = false;
        });
    },

    downloadSubmissionXML(orderId) {
      window.location = "/api/admin/efile/f4868/xml/submission/" + orderId;
    },
    downloadManifestXML(orderId) {
      window.location = "/api/admin/efile/f4868/xml/manifest/" + orderId;
    },
    downloadAckResponseXML(orderId) {
      window.location = "/api/admin/efile/f4868/xml/ack_response/" + orderId;
    },

    form4868ErrorCodesLabel(order) {
      let errors = order.efileErrorCodes;
      if (!errors) {
        return "";
      }
      errors = errors.entries;
      if (!errors || errors.length == 0) {
        return "";
      }

      if (errors.length == 1) {
        return errors[0].ruleNum;
      }
      if (errors.length == 2) {
        return errors[0].ruleNum + ", " + errors[1].ruleNum;
      }
      return errors[0].ruleNum + ", " + (errors.length - 1) + " others"
    },
    onForm4868ErrorCodes(order) {
      this.toShow = order;
      this.$refs.f4868ModalErrorCodes.show();
    },
    closeForm4868ErrorCodesModal() {
      this.toShow = {};
      this.$refs.f4868ModalErrorCodes.hide();
    },

    sendEmailNotification(sendNotification) {
      if (sendNotification) {
        this.disableButtons = true;
        AXIOS.post(`/admin/efile/f4868/id/${this.record.id}/sendEmailNotification`)
          .then((response) => {
            this.disableButtons = false;
            alert("Email sent!");
          })
          .catch((e) => {
            this.disableButtons = false;
            alert("Unable to send email!");
          });
      }
      this.$refs.emailNotificationModel.hide();
    },

    onConfirmRefresh() {
      let self = this;
      console.log("before map record = ", this.record);
      let orderInfo = this.record;

      console.log("before refreshOrder = ", orderInfo);
      self.refresh();
    },
    unpack(str) {
      var bytes = [];
      for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        bytes.push(char >>> 8);
        bytes.push(char & 0xff);
      }
      return bytes;
    },
    toParams(request, params = {}, prefix = null) {
      for (let [key, value] of Object.entries(request)) {
        let newKey = prefix ? `${prefix}.${key}` : key;
        if (value !== null && typeof value === "object") {
          this.toParams(value, params, newKey);
        } else {
          params[newKey] = value;
        }
      }
      return params;
    },

    chargebackCDRN() {
      let self = this;
      this.disableButtons = true;

      const authTransactionId = this.record.authorizeTransactionId;
      AXIOS.put(`/v2/admin/transaction/${authTransactionId}/voidOrRefundOnChargeBack`, {
        cbtype: 1,
        sendNotification: false,
        orderNum: this.record.id,
        type: "SYSTEM",
        content: "CDRN C/B DNS",
        user: self.loggedInUser.username,
      })
        .then((res) => {
          if (res.data.responseIdentifier != "Success") {
            this.alertManager("Chargeback");
            return;
          }

          alert("Transaction has chargeback");
          this.disableButtons = false;
          this.refresh();
          this.$refs.cbStatusModal.hide();
        })
        .catch((e) => {
          if (e.response.status === 409) {
            alert("Order void/refund can't be done more often than once in 10 seconds, please retry in short.");
            this.disableButtons = false;
            this.refresh();
            this.$refs.cbStatusModal.hide();
          } else {
            this.alertManager("Chargeback");
          }
        });
    },

    chargebackChase() {
      let self = this;
      this.disableButtons = true;

      const authTransactionId = this.record.authorizeTransactionId;
      AXIOS.put(`/v2/admin/transaction/${authTransactionId}/voidOrRefundOnChargeBack`, {
        cbtype: 2,
        sendNotification: false,
        orderNum: this.record.id,
        type: "SYSTEM",
        content: "CHASE C/B DNS",
        user: self.loggedInUser.username,
      })
        .then((res) => {
          let message = res.data.responseIdentifier == "Success"
            ? "Transaction has chargeback"
            : "Chargeback is not successful, alert a Manager to manually process the chargeback";

          alert(message);
          this.disableButtons = false;
          this.refresh();
          this.$refs.cbStatusModal.hide();
        })
        .catch((e) => {
          if (e.response.status === 409) {
            alert("Order void/refund can't be done more often than once in 10 seconds, please retry in short.");
          } else {
            alert("Chargeback is not successful, alert a Manager to manually process the chargeback");
          }
          this.disableButtons = false;
          this.refresh();
          this.$refs.cbStatusModal.hide();
        });
    },

    clickOnChargebackButton() {
      this.$refs.cbStatusModal.show();
    },

    clickOnHoldButton() {
      this.$refs.offHoldModal.show();
      this.record.status === "On Hold"
        ? (this.put_on_hold = "REMOVE HOLD")
        : (this.put_on_hold = "PUT ON HOLD");
    },
    putOnHold(sendNotification) {
      let self = this;

      console.log("[put on hold clicked!]", sendNotification);

      self.disableButtons = true;
      AXIOS.put(`/admin/efile/f4868/id/${this.$route.params.id}/onhold`, {
        sendNotification: sendNotification,
        orderNum: this.record.id,
        type: "SYSTEM",
        content: this.put_on_hold,
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.disableButtons = false;
          this.$refs.offHoldModal.hide();
          this.refresh();
        })
        .catch((e) => {
          alert("Unable to change status.");
          self.disableButtons = false;
        });
    },
    showHideCancelOrderConfirmation(isOpen) {
      isOpen
        ? this.$refs.cancelOrderModel.show()
        : this.$refs.cancelOrderModel.hide();
    },

    alertManager(process) {
      let successMessage = process + " is not successful, alert email is sent to a Manager";
      let failureMessage = process + " is not successful, error occurred while sending alert email to a Manager. Please alert a Manager to manually process the " + process.toLowerCase();

      AXIOS.put(`/alerts/notify/refund`, {
          orderPath: `/admin/form4868/${this.$route.params.id}`
        })
        .then((res) => {
          let informed = res.data.responseIdentifier === "Informed";
          alert(informed ? successMessage : failureMessage);
          this.$refs.cbStatusModal.hide();
          this.disableButtons = false;
          this.refresh();
        })
        .catch((e) => {
          alert(failureMessage);
          this.$refs.cbStatusModal.hide();
          this.disableButtons = false;
          this.refresh();
        });
    },

    cancelOrder() {
      this.showHideCancelOrderConfirmation();
      let self = this;
      this.disableButtons = true;
      const authTransactionId = this.record.authorizeTransactionId;

      AXIOS.put(`/v2/admin/transaction/${authTransactionId}/void`, {
          sendNotification: false,
          orderNum: this.record.id,
          type: "SYSTEM",
          content: "CANCEL AND REFUND",
          user: self.loggedInUser.username,
        })
        .then((res) => {
          if (res.data.responseIdentifier != "Success") {
            this.alertManager("Refund");
            return;
          }

          alert("Transaction has voided");
          this.disableButtons = false;
          this.refresh();
        })
        .catch((e) => {
          if (e.response.status === 409) {
            alert("Order void/refund can't be done more often than once in 10 seconds, please retry in short.");
            this.disableButtons = false;
            this.refresh();
          } else {
            this.alertManager("Refund");
          }
        });
    },

    hideManualStatusChangeModal() {
      this.manualStatus = "";
      this.$refs.manualStatusChangeModal.hide();
    },

    manualStatusChangeModalHidden() {
      this.manualStatus = "";
    },

    manualStatusChange() {
      if (this.manualStatus != "Cancelled") { // Currently supporting only one status
        return;
      }

      let self = this;
      AXIOS.put(`/admin/efile/f4868/id/${this.$route.params.id}/cancel`, {
        sendNotification: false,
        orderNum: this.record.id,
        type: "SYSTEM",
        content: "MANUALLY CANCELLED",
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.disableButtons = false;
          self.hideManualStatusChangeModal();
          self.refresh();
        })
        .catch((e) => {
          console.log(e);
          alert("Unable to manually change order's status");
          self.disableButtons = false;
          self.hideManualStatusChangeModal();
          self.refresh();
        });
    },

    refresh() {
      this.disableButtons = true;
      let self = this;

      AXIOS.get(`/admin/efile/f4868/id/${this.$route.params.id}`)
        .then((response) => {
          self.$set(self, "record", response.data);
          self.pastRecord = clone(response.data);

          //self.record.statusLastChanged = moment
          //  .unix(self.record.statusLastChanged / 1000)
          //  .format("MM/DD/YYYY h:mm:ss A");
          let today = new Date();
          let orderCreatedDate = new Date(self.record.createdDate);
          let dateDifference = Math.round(today - orderCreatedDate);
          let weekDifference = Math.round(
            dateDifference / 1000 / 60 / 60 / 24 / 7
          );
          let weeksAllowedToChangeStatus = self.loggedInUser.orderStatus;
          let weeksAllowedToEdit = self.loggedInUser.editRecord;
          let weeksAllowedToRefund = self.loggedInUser.refundPayment;

          if (
            self.loggedInUser.userType == "admin" ||
            (self.loggedInUser.userType == "StandardUser" &&
              weekDifference <= weeksAllowedToChangeStatus)
          ) {
            self.statusChangeAuth = true;
          }
          if (
            self.loggedInUser.userType == "admin" ||
            (self.loggedInUser.userType == "StandardUser" &&
              weekDifference <= weeksAllowedToEdit)
          ) {
            self.editRecordAuth = true;
          }
          if (
            self.loggedInUser.userType == "admin" ||
            (self.loggedInUser.userType == "StandardUser" &&
              weekDifference <= weeksAllowedToRefund)
          ) {
            self.voidRefundAuth = true;
          }
          this.disableButtons = false;

          let theBirthDate = this.record.birthDate;
          if (!!theBirthDate) {
            this.record.birthDate = moment(theBirthDate).format("YYYY-MM-DD");
          }
          let theSpouseBirthDate = this.record.spouseBirthDate;
          if (!!theSpouseBirthDate) {
            this.record.spouseBirthDate = moment(theSpouseBirthDate).format("YYYY-MM-DD");
          }
          console.log("[record]", this.record);
        })
        .catch((e) => {
          this.$router.push("/login");
          this.disableButtons = false;
        });
    },

    saveOrderDetails() {
      let self = this;
      this.disableButtons = true;

      const isEmailUpdate =
        this.record.email !== this.pastRecord.email ? true : false;
      console.log(this.record);

      AXIOS.put(`/admin/efile/f4868/id/${this.$route.params.id}/update`, {
        data: this.record,
        content: this.manual_note,
        emailChangeContent: isEmailUpdate ? "EMAIL - EDITED" : "",
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.addressesSaved = true;
          this.disableButtons = false;
          this.manual_note = "";
          if (response.data.email != null && isEmailUpdate) {
            this.emailNotificationModelData.title = "Update Email Address";
            this.emailNotificationModelData.content =
              "Would you like to send an email notification to the customer?";
            this.$refs.emailNotificationModel.show();
          }
          this.pastRecord = response.data;
          self.onConfirmRefresh();
          this.isEditMode = false;
        })
        .catch((e) => {
          console.log(e);
          this.$router.push("/login");
          this.disableButtons = false;
        });
      //}
    },
    isChargeBackAvailable(status) {
      return (
        (this.disableButtons && !this.isEditMode) ||
        (status !== "Processing" && status !== "Completed" && status !== "On Hold")
      );
    },
    backToResults(isRoute) {
      if (isRoute === true) {
        this.$refs.backConfirmation.hide();
        this.$router.push("/admin/orders");
      } else if (isRoute == false) {
        this.$refs.backConfirmation.hide();
      } else if (this.isEditMode) {
        this.$refs.backConfirmation.show();
      } else {
        this.$refs.backConfirmation.hide();
        this.$router.push("/admin/orders");
      }
    },
  },
  mounted() {
    let userInStorage = JSON.parse(localStorage.getItem("loggedUser"));
    this.loggedInUser =
      this.$store.getters.getUser != ""
        ? this.$store.getters.getUser
        : userInStorage
        ? userInStorage
        : "";

    this.refresh();
  },
};
</script>
<style scoped>
.aside-item h2 {
  font-size: 3em;
}
.aside-item p {
  font-size: 1.5em;
}
.home-page {
  /* background-image: url(./../assets/banner.jpg); */
  background-size: cover;
}

table,
th,
td {
  border: 2px solid lightgrey;
  border-collapse: collapse;
}
th,
td {
  padding: 5px;
  text-align: left;
  width: 50%;
}

hr {
  border: 0;
  clear: both;
  display: block;
  width: 100%;
  background-color: lightgray;
  height: 1px;
}
.hide-br {
  display: none;
}

@media (min-width: 64em) {
  .hide-br {
    display: initial;
  }
}

.business-address label {
  font-weight: 700 !important;
  margin-top: 0.25rem !important;
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Form4868OrderDetails.vue